module.exports = __webpack_public_path__ + "static/media/3.295b179c.png";